import React, { Component } from 'react';
import { connect } from 'react-redux';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import UserQuestionGroup from './UserQuestionsGroup';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import FileSaveAs from '../downloaders/FileSaveAs';
import _ from 'lodash';

export const FORM_NAME = 'USER_QUESTIONS_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

class UserQuestionsForm extends Component {

  constructor(props) {
    super(props);
    this.onFetchContent = this.onFetchContent.bind(this);
    this.onGenerateClick = this.onGenerateClick.bind(this);
  }

  onGenerateClick() {
    return this.props.onGenerateClick((this.props.formData && this.props.formData.fieldValues) || {});
  }

   onFetchContent() {   
    if(typeof this.props.downloadOptions.fetchContent === 'function') {
      return this.props.downloadOptions.fetchContent((this.props.formData && this.props.formData.fieldValues) || {});
    }
  }

  render() {
    log.debug('render(): ', this.props);
    const downloadComponent = this.props.showDownload ? (
      <div>
        <FileSaveAs downloadLabel={this.props.downloadOptions.downloadLabel || "Save As "} 
          className = {this.props.downloadOptions.buttonClass} 
          fetchContent={this.onFetchContent} 
          content={this.props.downloadOptions.content} 
          filename={this.props.downloadOptions.filename}  
          mimeType={this.props.downloadOptions.mimeType} 
          charset={this.props.downloadOptions.charset}
          isBlob={this.props.downloadOptions.isBlob} />
      </div>
    ): ('');

    const generateComponent = this.props.showGenerate === true ? (
      <button className="primary" onClick={this.onGenerateClick} >
          <LanguageStringResolver string='filingPage_Generate' />
      </button>
    ): (<></>);

    const groupedUserQuestions = this.props.userQuestions || {};
    const groupNames = Object.keys(groupedUserQuestions);
    let answers = {};
    if(this.props.formData && !_.isEmpty(this.props.formData.fieldValues)) {
      answers = this.props.formData.fieldValues;
    } else {
      answers = !_.isEmpty(this.props.initData) ? this.props.initData : (this.props.answers || {});
    }

    return (
      <div>
        <h2 className="mt15"><LanguageStringResolver string='filingPage_UserFields' /></h2>
        <hr className="mt20 mb20" />
        {groupNames.map((groupName, key) => (
          <div>
            <UserQuestionGroup
              key={key}
              groupName={groupName}
              userQuestions={groupedUserQuestions[groupName]}
              answers={answers}
              filingTypeId={this.props.filingTypeId}
              onFieldChangeHandlerFactory={this.onFieldChangeHandlerFactory.bind(this)}
            />
          </div>
        ))}
        {generateComponent}
        {downloadComponent}
        <div className="clear"></div>
      </div>
    );
  }
  
  UNSAFE_componentWillMount() {    
    if(!_.isEmpty(this.props.initData)) {
      this.props.doInitialiseForm(this.props.initData);
    }  else {
      this.props.doInitialiseForm(this.props.answers);
    }
  }

  //UserQuestionsForm do not have any submit click action. 
  //We are using unmout event to pass the form fields to the components
  //interested in update form data
  componentWillUnmount() {
    if(this.props.triggerSubmitOnUnmount) {
      let fieldValues = (this.props.formData && this.props.formData.fieldValues) || {};
      this.props.doFormSubmitted();
      this.props.onSubmit(this.props.name, fieldValues);      
    }
  }

  onFieldChangeHandlerFactory(fieldName) {
    return (evt) => {
      this.props.onFieldChange(fieldName, evt.target.value);
    }
  }
 
  onResetAnswers() {
    log.debug('onResetAnswers(): ');
    this.props.doResetForm(FORM_NAME);
  }
  
  onClearAnswers() {
    log.debug('onClearAnswers(): ');
    this.props.doClearForm(FORM_NAME);
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {

  return {
    formData: (state.managedUxForms && state.managedUxForms.forms[FORM_NAME])  || {}
  };
}


UserQuestionsForm.defaultProps = {
  showDownload: false,
  downloadOptions: {},
  onSubmit: () => {},
  triggerSubmitOnUnmount: false,
  showGenerate: false,
  onGenerateClick: ()=>{}
}

function mapDispatchersToProps(dispatch) {
  return {
    doInitialiseForm: (initialValues) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(FORM_NAME, initialValues));
    },
    doResetForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(FORM_NAME));
    },
    doClearForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(FORM_NAME));
    },
    onFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(FORM_NAME, fieldName, value));
    },
    doFormSubmitted: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(FORM_NAME));
    }
  }
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(UserQuestionsForm);
